import LoadingIcon from '../assets/icons/loading.svg';
import PropTypes from 'prop-types';
import React from 'react';
import {Box, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

const StyledLoadingIcon = styled(LoadingIcon)(({theme}) => ({
  width: theme.spacing(2),
  height: theme.spacing(2),
  fill: theme.palette.text.secondary,
  '&:not(:last-child)': {
    marginRight: theme.spacing(1),
  },
}));

const LoadingIndicator = ({children, ...props}) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    padding={2}
    color="text.secondary"
    {...props}
  >
    <StyledLoadingIcon />
    {children && <Typography variant="body2">{children}</Typography>}
  </Box>
);

LoadingIndicator.propTypes = {
  children: PropTypes.node,
};

export default LoadingIndicator;
